import React, { useEffect, useRef, useState } from 'react';

type FillPNGIconProps = {
  src: string;
  color: string;
  size?: number;
  showLoading?: boolean;
};

export const FillPNGIcon: React.FC<FillPNGIconProps> = ({
  src,
  color,
  size = 24,
  showLoading = false,
}) => {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setDataUrl(recolorImage(img, color, size, size));
    };
    imgRef.current = img;
  }, [src, color, size]);

  return dataUrl ? (
    <img
      src={dataUrl}
      alt="game type icon"
      style={{ width: size, height: size }}
    />
  ) : showLoading ? (
    <span>Loading...</span>
  ) : (
    <div style={{ width: size, height: size }} />
  );
};

const recolorImage = (
  img: HTMLImageElement,
  color: string,
  width: number,
  height: number,
): string => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('2D context not supported or canvas already initialized');
  }

  canvas.width = width;
  canvas.height = height;

  // Draw the image on the canvas
  ctx.drawImage(img, 0, 0, width, height);

  // Set the global composite operation to source-in to keep the alpha channel
  ctx.globalCompositeOperation = 'source-in';

  // Set the fill color
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, width, height);

  return canvas.toDataURL();
};
